/* eslint-disable */
import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

export default function Row({ row, limit, thereIsComponent }) {
  return (
    <React.Fragment>
      <TableRow
        sx={{
          '&:last-child td, &:last-child th': { border: 0 },
          background: 'white',
        }}
      >
        {row.map((data, j) =>
          j < limit ? (
            <TableCell key={j} align="center" style={{}}>
              {thereIsComponent ? thereIsComponent(row, j) : data}
            </TableCell>
          ) : null
        )}
      </TableRow>
    </React.Fragment>
  );
}
